import React from "react";
import { createPortal } from "react-dom";
import { Scrollx_animate } from "../../assets/icons";

export default function Loader({ label }) {
  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(6, 5, 12, 0.72)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <img
        src={Scrollx_animate}
        alt="Loading"
        height={120}
        width={120}
        style={{ display: "block", opacity: 0.85 }}
      />
      {label ? (
        <div
          style={{
            marginTop: 12,
            fontSize: 15,
            color: "#fff",
            textAlign: "center",
            fontFamily: "var(--font-body), Manrope, sans-serif",
          }}
        >
          {label}
        </div>
      ) : null}
    </div>,
    document.body,
  );
}
